import { render, staticRenderFns } from "./MannequinDiagramFront.vue?vue&type=template&id=45220b2f"
import script from "./MannequinDiagramFront.vue?vue&type=script&lang=js"
export * from "./MannequinDiagramFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports